import type { Option } from '@mylighthouse/prism-ember/types/components/prism/select-input';

export const DROPDOWN_LOS_SORT_OPTIONS = {
  MY_HIGHEST_PERFORMING: 'my_highest_performing',
  PRIMARY_COMPARISON_SET_HIGHEST_PERFORMING:
    'primary_comparison_set_highest_performing',
  HIGHEST_POSITIVE_DIFFERENCE_VS_PRIMARY_COMPARISON_SET:
    'highest_positive_difference_vs_primary_comparison_set',
  HIGHEST_NEGATIVE_DIFFERENCE_VS_PRIMARY_COMPARISON_SET:
    'highest_negative_difference_vs_primary_comparison_set',
} as const;

export type DropdownLosSortOption =
  (typeof DROPDOWN_LOS_SORT_OPTIONS)[keyof typeof DROPDOWN_LOS_SORT_OPTIONS];

export type DropdownLosSortOptionType = Option & {
  id: DropdownLosSortOption;
  label: string;
};
